export const validateUrl = (providedUrl) => {
	let url
	let str = ""

	if (
		!providedUrl.startsWith("https://") &&
		!providedUrl.startsWith("http://")
	) {
		str = `https://${providedUrl}`
	} else {
		str = providedUrl
	}

	try {
		url = new URL(str)
	} catch (_) {
		return ""
	}

	return url.protocol === "http:" || url.protocol === "https:" ? url.href : ""
}
